import React from "react";
import { Link } from "react-router";

const IndexPage = () => {
    return (
        <>
            <h1 className="mt-6 mb-4 text-4xl font-extrabold leading-none tracking-tight text-gray-900">
                Packages
            </h1>
            <Link className="btn btn-blue" to="/P/LGW-LHR-LTN-LCY/GR/7/2026-06-01/2026-06-30/A2">
                Package Search 1x room
            </Link>
            <Link
                className="btn btn-blue"
                to="/P/LGW-LHR-LTN-LCY/GR/7/2026-06-01/2026-06-30/A2-A2C3C"
            >
                Package Search 2x room
            </Link>
        </>
    );
};
export default IndexPage;
